import CollapsibleNavigation from './CollapsibleNavigation';
import './style/index.less';

export default CollapsibleNavigation;
